/**
 * GPU Data Adapter
 *
 * Loads GPU detail data and merges with pricing data from separate files.
 * Uses the generic adapter pattern for consistency.
 */

import type { GPUModel } from '../../models/gpu/gpu-model'
import { createSingletonAdapter, type GenericDataAdapter } from '../common/GenericDataAdapter'

// Create singleton instance using generic adapter
const { getAdapter, resetAdapter } = createSingletonAdapter<GPUModel>({
  basePath: '/data/gpu',
  componentName: 'gpu'
})

/**
 * Get the singleton instance of GPUDataAdapter
 */
export function getGPUDataAdapter(): GenericDataAdapter<GPUModel> {
  return getAdapter()
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetGPUDataAdapter(): void {
  resetAdapter()
}

// Re-export for backward compatibility
export type GPUDataAdapter = GenericDataAdapter<GPUModel>
